import React, { useEffect, useImperativeHandle, useState } from "react"
import CardSection from "../../../../../components/ui/card/CardSection"
import PermissionList from "./PermissionList"
import SwalAlert from "../../../../../services/swalService/SwalService";
import { useAddSecurityPermissionsMutation, useLazyGetAllPagesByRoleIdQuery } from "../../../../../app/services/securityPermissionAPI";
import { GetPermissionData, GetPermissionTreeData } from "./generateTreeData";
import { useDispatch } from "react-redux";
import { logout } from "../../../../../app/slice/authSlice";

const ManagePermission = ({ togglePermissionCard, selecteRoleId, childRef }) => {

  const { confirm } = SwalAlert();
  const dispatch = useDispatch();
  const [permissionItem, setPermissionItem] = useState([]);
  const [permissionsData, setPermissionsData] = useState([]);

  const [addSecurityPermissions, {
    isSuccess: isPermissionsAdded,
    data: isAddPermissionsData
  },] = useAddSecurityPermissionsMutation();

  const [getAllPagesByRoleId, {
    isFetching: isGetByIdLoading,
    isSuccess: isPermissionSuccess,
    data: permissionData,
  },] = useLazyGetAllPagesByRoleIdQuery();

  const onUpdatePermission = (data) => {
    setPermissionsData(data);
    onPermissionItemSet(data);
  };
  const onPermissionItemSet = (permissionTreeItem) => {
    setPermissionItem(permissionTreeItem);
  };
  const handleSavePermission = () => {

    if (permissionItem && permissionItem.length > 0) {
      let permissionSettingList = GetPermissionData(permissionItem);
      const transformedData = permissionSettingList.map((item) => ({
        securitySettingId: item.securitySettingId,
        securityKeyId: item.securityKeyId,
        roleId: item.roleId,
      }));

      const requestData = {
        securityPermissionsList: transformedData,
      };
      addSecurityPermissions(requestData);
    }
    // setTogglePermissionCard(true);
  };
  useEffect(() => {
    if (isPermissionsAdded && isAddPermissionsData) {
      confirm(
        "Security Permissions Updated!",
        "You will be logged out! Please Log In again",
        "Log Out",
        "Cancel",
        false
      ).then((confirmed) => {
        if (confirmed) {
          dispatch(logout());
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPermissionsAdded, isAddPermissionsData]);

  useEffect(() => {
    if (isPermissionSuccess && permissionData) {
      const data = GetPermissionTreeData(permissionData);
      onPermissionItemSet(data);
      setPermissionsData(data);
    }
  }, [isPermissionSuccess, permissionData]);
  const getPermissionList = (selectedRoleId) => {
    getAllPagesByRoleId(selectedRoleId.value);
  };

  //** Use Imperative Handle  */
  useImperativeHandle(childRef, () => ({
    callChildFunction: getPermissionList,
  }));

  return (
    <React.Fragment>
      {togglePermissionCard && selecteRoleId ? (
        <div className="permission-list">
          <CardSection
            isContentLoading={isGetByIdLoading}
            cardTitle="Security Permissions"
            rightButton={true}
            buttonText="Save Permissions"
            buttonClassName="btn theme-btn"
            titleButtonClick={handleSavePermission}
          >
            <PermissionList
              onPermissionSet={onPermissionItemSet}
              onUpdatePermission={onUpdatePermission}
              isLoading={isGetByIdLoading}
              permissionsData={permissionsData}
            />
          </CardSection>
        </div>
      ) : null}
    </React.Fragment>
  )
}
export default ManagePermission